import { competitionSelectors } from './../../competition.selectors'
import { authSelectors } from './../../../../core/auth/auth.selectors'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { Member } from 'src/app/features/member/member'
import { CompetitionTeam } from '../competition-team'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
@UntilDestroy()
@Component({
  selector: 'competition-team-creation-confirmation-card',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CompetitionTeamCreationConfirmationCardComponent
  implements OnInit
{
  @Input() teamsOfMember: CompetitionTeam[]
  @Output() onSubmit = new EventEmitter<any>()
  public teamId$: Observable<number>
  public team$: Observable<CompetitionTeam>
  public currentMember: Member
  public showExistingTeams: boolean = false
  public form: UntypedFormGroup

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private router: Router,
    private bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      selectedTeamId: [null, [Validators.required]]
    })

    this.store.select(authSelectors.selectMember).subscribe((member) => {
      this.currentMember = member
    })
    this.store.select(competitionSelectors.selectEntities)
  }

  public onFormSubmit() {
    this.onSubmit.emit(true)
  }

  public onClickClose() {
    this.onSubmit.emit(false)
  }

  public onClickConfirmSettings() {
    if (this.teamsOfMember?.length > 1) {
      this.showExistingTeams = true
    }

    if (this.teamsOfMember?.length == 1) {
      this.form.controls.selectedTeamId.setValue(this.teamsOfMember[0].id)
      this.onSelectTeamFormSubmit()
    }
  }

  public onSelectTeamFormSubmit() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })
      console.log('%cForm is invalid', 'color: red; font-weight: bold;')
      return
    }

    this.bsModalRef.hide()

    this.router.navigate([
      `/competition-team/${this.form.value.selectedTeamId}/create`
    ])
  }
}
